import i18n from '@/i18n';
import router from '@/router/index';
import TimeEntryService from '@/api/TimeEntryService';
import ActivityAreaService from '@/api/ActivityAreaService';
import MemberService from '@/api/MemberService';
import AttachedFileService from '@/api/AttachedFileService';
import cloneDeep from 'lodash/cloneDeep';

const state = {
  selectedWeekTimeEntries: [],
  selectedWeekTimeEntriesNotSubmitted: [],
  addedTimeEntryid: null,
  selectedTimeEntry: {
    employer: {},
    activityArea: {},
    attachedFiles: [],
    expenses: [],
  },
  selectedTimeEntryEmployers: [],
};

const getters = {};

const actions = {
  resetTimeEntry({ commit }) {
    commit('selectedTimeEntry', {
      employer: {},
      activityArea: {},
      attachedFiles: [],
      expenses: [],
      hasNotWorked: false,
    });
  },
  submit({ dispatch }, date) {
    return TimeEntryService.submit(date).then(() => dispatch('currentWeekTimeEntries'));
  },
  deleteTimeEntryPhoto({ commit }, args) {
    return TimeEntryService.getTimeEntryById(args.timeEntryId).then(
      (response) => {
        let index = null;
        response.data.attachedFiles.some((attachedFile, i) => {
          if (String(attachedFile.id) === String(args.photoId)) {
            index = i;
            return true;
          }

          return false;
        });

        response.data.attachedFiles.splice(index, 1);
        return TimeEntryService.saveTimeEntry(args.timeEntryId, response.data)
          .then(() => AttachedFileService.deleteFileById(args.photoId))
          .then(() => {
            commit(
              'alerts/setAlert',
              {
                msg: i18n.t('PHOTO.DELETE_CONFIRMATION_MESSAGE'),
              },
              {
                root: true,
              },
            );
            router.push(`/dashboard/time-entries/${args.timeEntryId}`);
          });
      },
    );
  },
  addTimeEntryPhoto({ commit }, args) {
    return AttachedFileService.addAttachedFile(args.data)
      .then(response => TimeEntryService.getTimeEntryById(args.timeEntryId).then(
        (response2) => {
          response2.data.attachedFiles.push(response.data);
          return TimeEntryService.saveTimeEntry(args.timeEntryId, response2.data);
        },
      ))
      .then(() => {
        commit(
          'alerts/setAlert',
          {
            msg: i18n.t('PHOTO.ADD_CONFIRMATION_MESSAGE'),
          },
          {
            root: true,
          },
        );
        router.push(`/dashboard/time-entries/${args.timeEntryId}`);
      });
  },
  saveTimeEntry({ commit }, args) {
    return TimeEntryService.saveTimeEntry(args.id, args).then(() => {
      commit(
        {
          root: true,
        },
      );
    });
  },
  deleteTimeEntry({ commit }, id) {
    return TimeEntryService.deleteTimeEntry(id).then(() => {
      commit(
        'alerts/setAlert',
        {
          msg: i18n.t('TIME_ENTRIES.DELETE_CONFIRMATION_MESSAGE'),
        },
        {
          root: true,
        },
      );
      router.push('/dashboard/time-entries');
    });
  },
  timeEntryById({ commit }, id) {
    return TimeEntryService.getTimeEntryById(id).then((response) => {
      commit('selectedTimeEntry', response.data);
    });
  },
  currentWeekTimeEntries({ commit }) {
    return TimeEntryService.getCurrentWeekTimeEntries().then((response) => {
      commit('selectedWeekTimeEntries', response.data);
      commit(
        'selectedWeekTimeEntriesNotSubmitted',
        response.data.filter(timeEntry => timeEntry.isSubmitted === false),
      );
    });
  },
  rangeDateTimeEntries({ commit }, args) {
    return TimeEntryService.getWeekTimeEntriesFromDate(
      args.fromDate,
      args.toDate,
    ).then((response) => {
      commit('selectedWeekTimeEntries', response.data);
      commit(
        'selectedWeekTimeEntriesNotSubmitted',
        response.data.filter(timeEntry => timeEntry.isSubmitted === false),
      );
    });
  },
  addTimeEntry({ commit }, data) {
    const addTimeEntry = (newData) => {
      TimeEntryService.addTimeEntry(newData).then((response) => {
        if (!response.error) {
          commit('addedTimeEntryid', response.data.id);
          commit(
            {
              root: true,
            },
          );
        }
      });
    };
    if (data.activityArea && data.activityArea.id && data.employer && data.employer.id) {
      return Promise.all([
        ActivityAreaService.getActivityAreaById(data.activityArea.id),
        MemberService.getCurrentMemberEmployer(data.employer.id),
      ]).then(([response1, response2]) => {
        const newData = cloneDeep(data);
        newData.activityArea = response1.data;
        newData.employer = response2.data;
        addTimeEntry(newData);
      });
    }
    if (data.employer && data.employer.id) {
      return MemberService.getCurrentMemberEmployer(data.employer.id).then((response) => {
        const newData = cloneDeep(data);
        newData.employer = response.data;
        addTimeEntry(newData);
      });
    }
    return addTimeEntry(data);
  },
};

const mutations = {
  selectedWeekTimeEntries(state, payload) {
    state.selectedWeekTimeEntries = payload;
  },
  selectedTimeEntry(state, payload) {
    state.selectedTimeEntry = payload;
  },
  addedTimeEntryid(state, payload) {
    state.addedTimeEntryid = payload;
  },
  selectedWeekTimeEntriesNotSubmitted(state, payload) {
    state.selectedWeekTimeEntriesNotSubmitted = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
